import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('admin/bo/logout', params).then((response) => {
        return response.data;
    });
};
export const useMutationLogout = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    token: string;
    username: string;
}
